import React from 'react'
import { IoIosMail } from 'react-icons/io'
import LoginBanner from 'components/shared/LoginBanner'
import InputTextField from 'components/ui/InputTextField'
import Button from 'components/ui/Button'

const ForgetPassword = () => {
  return (
    <div className="grid grid-cols-1 bg-[#F2F2F2] md:grid-cols-2">
      <div className="flex flex-wrap flex-col justify-center px-1  h-svh md:px-32">
        <div className="text-4xl font-bold">
          Forgot Your Password
        </div>
        <div className="mt-4 text-lg text-lightGrey">
          Enter your email and we will send you link to reset your<br />
          password.
        </div>
        <div className="mt-3">
          <InputTextField
            label="Email*"
            type="text"
            icon={<IoIosMail size={24} />}
            placeholder="Enter your mail"
          />
        </div>
        <div className='mt-2 text-lightGrey text-sm font-normal'>In case you didn't receive mail, click on button and we'll send it again</div>
        <div className="mt-7">
          <Button title="Send Reset Link" />
        </div>
      </div>
      <LoginBanner />
    </div>
  )
}

export default ForgetPassword